import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/admin/announcements/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/dashboard/admin/announcements/"!</div>
}
